import cx from "classnames";

import { VideoBlock as VideoBlockType } from "../../types";

import styles from "../../styles/VideoBlock.module.less";

type VideoBlockProps = {
  className: string;
  block: VideoBlockType;
};

const VideoBlock = ({ block, className }: VideoBlockProps) => {
  return (
    // Video is for the background and wont have captions
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      autoPlay={true}
      loop={true}
      muted={true}
      playsInline={true}
      className={cx(styles.video, block.shadow && styles.shadow, className)}
    >
      <source src={block.source} />
    </video>
  );
};

export default VideoBlock;
